import React, { useState } from 'react';
import { uploadImage, STORAGE_PATHS } from '../../services/firebase-storage.js';
import { API } from '../../utils/database-frontend.js';

const NewsForm = ({ onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    publishedDate: new Date().toISOString().split('T')[0],
    image: null
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.description || !formData.image || !formData.publishedDate) {
      onError('❌ Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);
    
    try {
      // Upload image to Firebase Storage
      const uploadResult = await uploadImage(
        formData.image,
        STORAGE_PATHS.NEWS,
        `news-${Date.now()}.${formData.image.name.split('.').pop()}`
      );

      // Add to PostgreSQL database
      const newsData = {
        Title: formData.title,
        Description: formData.description,
        ImageUrl: uploadResult.url,
        FirebaseImagePath: uploadResult.path,
        PublishedDate: formData.publishedDate
      };

      await API.news.create(newsData);
      
      onSuccess('✅ Haber başarıyla eklendi!');
      
      // Reset form
      setFormData({
        title: '',
        description: '',
        publishedDate: new Date().toISOString().split('T')[0],
        image: null
      });
      
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      onError('❌ Haber eklenirken hata oluştu: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">📰 Yeni Haber Ekle</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Haber Başlığı
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            placeholder="Örn: Yeni Fabrika Açıldı"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Haber İçeriği
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="5"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            placeholder="Haber içeriği detayları..."
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Yayınlanma Tarihi
          </label>
          <input
            type="date"
            name="publishedDate"
            value={formData.publishedDate}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Haber Görseli
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
          {formData.image && (
            <p className="mt-2 text-sm text-gray-600">
              Seçilen dosya: {formData.image.name}
            </p>
          )}
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition duration-300"
        >
          {loading ? '⏳ Ekleniyor...' : '✅ Haber Ekle'}
        </button>
      </form>
    </div>
  );
};

export default NewsForm; 